// OrderPage.jsx
import React, { useState, useEffect, useRef } from "react";
import FloatingOrderButton from "../components/FloatingOrderButton";
import ConfirmationModal from "../Modals/ConfirmationModal";
import ItemModal from "../Modals/ItemModal";
import EditModal from "../Modals/EditModal";
import { getMenu, getIngredSetting, fullMenu } from "../api/apis";
import { useApp } from "../Context";
import { emptyCart, fetchCart, setCart } from "../util/PurchaseManager";

export default function OrderPage() {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState({});
  const [activeCategory, setActiveCategory] = useState("0001");
  const [editable, setEditable] = useState(false);
  const [settings, setSettings] = useState({});

  const { getCfg, getMenu: contextMenu, sid } = useApp();
  const navbarRef = useRef(null);
  const isManuallyScrolling = useRef(false);

  const [order, setOrder] = useState([]);
  const [sum, setSum] = useState(0);
  const [orderItem, setOrderItem] = useState(null);
  const [editIndex, setEditIndex] = useState(-1);
  const [showOrder, setShowOrder] = useState(false);

  useEffect(() => {
    if (!contextMenu?.length) return;

    setCategories(contextMenu);
    setActiveCategory(contextMenu[0]?.id || "0001");

    const fetchItems = async () => {
        fullMenu(contextMenu).then(res=>{
            if(res.ok){
                setData(res.data)
            }else{
                for (const category of contextMenu) {
                    getMenu(category.id).then(items=>{
                        setData(prev=>({...prev,[category.id]: items}))
                    })
                }
            }
        })
      
    };

    fetchItems();
  }, [contextMenu]);

  useEffect(() => {
    getCfg().then(cfg => setEditable(!!cfg.editable));
    getIngredSetting().then(res => setSettings(res.data));

    const storage = fetchCart(sid)
    setOrder(storage?.items ?? []);
    setSum(storage?.sum ?? 0);
  }, []);

  useEffect(() => {
  const navbar = navbarRef.current;
  if (!navbar) return;

  // Use the parent nav-item, not just the <a> tag
  const activeNavItem = navbar.querySelector(`.nav-item a[href="#${activeCategory}"]`)?.parentElement;
  if (!activeNavItem) return;

  // Compute position relative to navbar scroll
  const navItemLeft = activeNavItem.offsetLeft;
  const navItemWidth = activeNavItem.offsetWidth;
  const navbarWidth = navbar.offsetWidth;

  // Scroll so it's centered (or close to it)
  const scrollTo = navItemLeft - (navbarWidth / 2) + (navItemWidth / 2);

  navbar.scrollTo({
    left: scrollTo,
    behavior: 'smooth',
  });
}, [activeCategory]);


  useEffect(() => {
    const handleScroll = () => {
      if (isManuallyScrolling.current) return;

      let closestId = categories[0]?.id ?? '0001';
      let minOffset = Infinity;

      categories.forEach(category => {
        const section = document.getElementById(category.id);
        if (section) {
          const offset = Math.abs(section.getBoundingClientRect().top);
          if (offset < minOffset) {
            minOffset = offset;
            closestId = category.id;
          }
        }
      });

      setActiveCategory(closestId);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [categories]);

  const addToCart = (item) => {
    const updatedOrder = [...order, {
      ...item,
      finalPrice: item.finalPrice ?? item.price,
      customizations: item.customizations ?? { add_ons: [], sides: [], removed: [] }
    }];
    const updatedSum = sum + (item.finalPrice ?? item.price) / 100;
    setOrder(updatedOrder);
    setSum(updatedSum);
    console.log(setCart(sid, updatedOrder, updatedSum))
  };

  const editItem = (newItem) => {
    const updatedOrder = [...order];
    updatedOrder[editIndex] = newItem;
    const updatedSum = updatedOrder.reduce((acc, item) => acc + (item.finalPrice ?? item.price) / 100, 0);
    setOrder(updatedOrder);
    setSum(updatedSum);
    setCart(sid, updatedOrder, updatedSum);
  };

  const removeFromCart = (index) => {
    if (index < 0 || index >= order.length) return;
    const updatedOrder = [...order];
    const removedItem = updatedOrder.splice(index, 1)[0];
    const itemPrice = (removedItem.finalPrice ?? removedItem.price) / 100;
    const updatedSum = Math.max(sum - itemPrice, 0);
    setOrder(updatedOrder);
    setSum(updatedSum);
    setCart(sid, updatedOrder, updatedSum);
    setEditIndex(-1);
  };

  const clearCart = () => {
    setOrder([]);
    setSum(0);
    emptyCart()
  };

  function Description({ item }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <p
      className={`text-muted small m-0 ${!expanded ? "text-truncate" : ""}`}
      style={{ cursor: "pointer" }}
      onClick={() => setExpanded(!expanded)}
      title={item.desc.toSwe()} // optional: show full text on hover
    >
      {item.desc.toSwe()}
    </p>
  );
}

  return (
    <div>
      <div className="position-fixed bg-white shadow-sm m-auto" style={{ zIndex: 1000, top: "50px", width: "100vw", maxWidth: "500px" }}>
        <div className="container">
          <div className="d-flex overflow-auto py-1 gap-2" ref={navbarRef} style={{ whiteSpace: "nowrap", overflowX: "auto", overflowY: "hidden", scrollBehavior: "smooth" }}>
            {categories.map(category => (
              <div key={category.id} className="nav-item me-3 position-relative">
                <a className={`nav-link text-dark fw-semibold pb-1 ${activeCategory === category.id ? "active-category" : ""}`} href={`#${category.id}`} onClick={(e) => {
                  e.preventDefault();
                  const section = document.getElementById(category.id);
                  if (section) {
                    isManuallyScrolling.current = true;
                    section.scrollIntoView({ behavior: 'smooth' });
                    setActiveCategory(category.id);
                    setTimeout(() => isManuallyScrolling.current = false, 1000);
                  }
                }}>
                  {category.name.replace("_", " ")}
                  <span className="position-absolute start-50 translate-middle-x" style={{ bottom: 0, width: activeCategory === category.id ? "110%" : "0%", height: "2px", backgroundColor: "#ffc107", borderRadius: "3px", transition: "width 0.3s ease-in-out" }}></span>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="pt-5 mt-5" style={{ paddingTop: "110px", paddingBottom: "5rem" }}>
        {categories.map(category => (
          <div key={category.id} id={category.id} className="mb-4" style={{ scrollMarginTop: "100px" }}>
            <h4 className="text-center fw-bold text-dark">{category.name.charAt(0).toUpperCase() + category.name.slice(1)}</h4>
            <div className="d-flex flex-column justify-content-center gap-3">
              {data[category.id]?.map(item => (
                <div key={item.plu} className="card border-0 shadow-sm h-100" style={{ borderRadius: "15px", overflow: "hidden", background: "#fff" }}>
                  <div className="px-3 py-2">
                    <h6 className="fw-bold text-dark mb-1">{item.text.toSwe()}</h6>
                    <Description item={item}/>
                  </div>
                  <div className="d-flex justify-content-between align-items-center px-3 pb-2">
                    <p className="m-0 fw-bold fs-6 text-muted">{(item.price / 100)} kr</p>
                    <div className="d-flex gap-1">
                      <button className="btn btn-warning btn-sm px-3 rounded-3 fw-semibold" onClick={() => {
                        const forceChoices = item.pbo.iga.some(({ p0sort: sort }) => {
                            const cat = sort[0];
                            return settings[cat]?.hasSubtypes;
                          });
                        if(forceChoices){
                          setOrderItem(item)
                          return;
                        }
                        addToCart(item)
                      }}>Lägg till</button>
                      {editable && <button className="btn btn-secondary btn-sm rounded-3 fw-semibold" onClick={() => setOrderItem(item)}><i className="bi bi-pencil-square" /></button>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <FloatingOrderButton order={order} sum={sum} setShowModal={setShowOrder} />
      {editIndex > -1 && order[editIndex] ? (
        <EditModal item={order[editIndex]} setItem={() => setEditIndex(-1)} add={editItem} settings={settings} />
      ) : orderItem ? (
        <ItemModal item={orderItem} setItem={setOrderItem} add={addToCart} settings={settings} />
      ) : showOrder ? (
        <ConfirmationModal
  showOrder={showOrder}
  setShowOrder={setShowOrder}
  order={order}
  sum={sum}
  removeFromCart={removeFromCart}
  clear={clearCart}
  editCart={setEditIndex}
  refresh={editIndex}
/>

      ) : null}
    </div>
  );
}